/**
 * 채팅 아바타 헬퍼 — Claude Design(Pple Chat.dc.html)의 이니셜+틴트 아바타 규칙을 옮긴 것.
 * 프로필 이미지가 없을 때 이름 첫 글자 + 결정적 틴트 색으로 아바타를 만든다.
 */

export type AvatarTint = { tint: string; ink: string };

// 디자인의 틴트/잉크 팔레트
const PALETTE: AvatarTint[] = [
  { tint: '#FFE3DC', ink: '#FF4651' },
  { tint: '#E7F0FF', ink: '#3B6FD4' },
  { tint: '#E5F5EC', ink: '#2E9B62' },
  { tint: '#FFF3D6', ink: '#C38A00' },
  { tint: '#F0EBFF', ink: '#6B4FD8' },
];

/** 이름/uuid 기반 결정적 틴트 선택 */
export const avatarTint = (key: string): AvatarTint => {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
};

/** 이름 첫 글자(이니셜) */
export const avatarInitial = (name?: string | null): string => {
  const trimmed = (name ?? '').trim();
  return trimmed ? trimmed[0] : '?';
};

/** "오전/오후 h:mm" */
export const formatChatTime = (iso?: string | null): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const h = d.getHours();
  const m = d.getMinutes();
  const ampm = h < 12 ? '오전' : '오후';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${ampm} ${h12}:${String(m).padStart(2, '0')}`;
};

/** "M월 D일 요일" (날짜 구분선용) */
export const formatChatDate = (iso?: string | null): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const days = ['일', '월', '화', '수', '목', '금', '토'];
  return `${d.getMonth() + 1}월 ${d.getDate()}일 ${days[d.getDay()]}요일`;
};

/** 두 ISO가 같은 날짜인지 (구분선 삽입 판단) */
export const isSameDay = (a?: string | null, b?: string | null): boolean => {
  if (!a || !b) return false;
  const da = new Date(a);
  const db = new Date(b);
  return (
    da.getFullYear() === db.getFullYear() &&
    da.getMonth() === db.getMonth() &&
    da.getDate() === db.getDate()
  );
};
